module.exports = __webpack_public_path__ + "static/BFB_TRAIN_WOMAN_OOH-02193cab1bbbdedc5c9b7f7398fc58fe.jpg";